import LinkTag from '@/components/common/link-tag';
import { ROUTES } from '@/types/common';
import { HospitalSearchParamsQueries } from '@/types/hospital';
import React, { ReactNode } from 'react';
import styled, { css } from 'styled-components';

interface Props {
  children: ReactNode;
}

interface TextProps {
  text: string;
}

interface OnClickProps extends TextProps {
  onClick: () => void;
}

const FindHospitalTreatments = ({ children }: Props) => {
  return <Wrapper>{children}</Wrapper>;
};

const Title = ({ text }: TextProps) => {
  return <FindTitle>{text}</FindTitle>;
};

const Treatments = ({ children }: Props) => {
  return <TreatmentsWrapper>{children}</TreatmentsWrapper>;
};
const Treatment = ({ text, onClick }: OnClickProps) => {
  return (
    <LinkTag
      href={`${ROUTES.HOSPITAL.SEARCH.path}?${HospitalSearchParamsQueries.Keyword}=${text}&${HospitalSearchParamsQueries.Mode}=NEAR&${HospitalSearchParamsQueries.SortType}=DISTANCE`}
      onClickNavigateToScreen={onClick}
    >
      <TreatmentWrapper>
        <h3>{text}</h3>
      </TreatmentWrapper>
    </LinkTag>
  );
};
const MoreSee = ({ text, onClick }: OnClickProps) => {
  return (
    <MoreSeeButton type='button' onClick={onClick}>
      {text}
    </MoreSeeButton>
  );
};

export default FindHospitalTreatments;

FindHospitalTreatments.Title = Title;
FindHospitalTreatments.Treatments = Treatments;
FindHospitalTreatments.Treatment = Treatment;
FindHospitalTreatments.MoreSee = MoreSee;

const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
`;

const FindTitle = styled.h2`
  ${({ theme }) => css`
    ${theme.typography.UI19SB}
    color: ${theme.color.gray700};
    display: flex;
    align-items: center;
    padding: 0 24px;
    height: 32px;
    margin-top: 32px;
  `}
`;

const TreatmentsWrapper = styled.ul`
  display: flex;
  flex-wrap: wrap;
  overflow: hidden;
  gap: 8px;
  padding: 0 24px;
  margin-top: 24px;
  margin-bottom: 80px;
`;

const TreatmentWrapper = styled.li`
  ${({ theme }) => css`
    background: ${theme.color.gray30};
    height: 40px;
    padding: 0 16px;
    & > h3 {
      ${theme.typography.UI15M}
      color: ${theme.color.gray600};
    }
  `}
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 25px;
`;

const MoreSeeButton = styled.button`
  ${({ theme }) => `
    ${theme.typography.UI17M}
    color: ${theme.color.gray500};
    border-top: 1px solid ${theme.color.gray50};
    border-bottom: 1px solid ${theme.color.gray50};
`}
  padding: 16px 0;
  display: flex;
  justify-content: center;
  align-items: center;
`;
